import gql from 'graphql-tag';
export const GET_LANGUAGES = gql `
  query Language {
    languages {
      name
      code
      short
    }
  }
`;
//# sourceMappingURL=language.list.js.map